import React, {Component} from 'react';
import {t} from '@lingui/macro';
import {connect} from 'react-redux';
import {Modal} from 'antd';
import ListMenu from "..";
import ProductBundleActions from '../../../redux/ProductBundle/actions';
import { SubscriptionScopeKey } from '../../Access/helper/subscription/enum/SubscriptionScopeKey';

const {
    archiveBundle,
    deleteBundle,
} = ProductBundleActions;

class ProductBundleListMenu extends Component {
    toggleActivation = record => {
        const { archiveBundle } = this.props;
        const isArchived = record.is_archived;

        Modal.confirm({
            title: (isArchived ? t`Activate Product Bundle` : t`Deactivate Product Bundle`),
            content: isArchived ?
                t`Do you really want to activate bundle ${record.name}?` :
                t`Do you really want to deactivate bundle ${record.name}?`,
            onOk() {
                archiveBundle(record.id, {
                    is_archived: !isArchived,
                });
            },
            onCancel() {},
            okText: (isArchived ? t`Activate` : t`Deactivate`),
            cancelText: t`Cancel`,
        });
    };

    deleteBundle = record => {
        const { deleteBundle } = this.props;

        Modal.confirm({
            title: t`Delete Product Bundle`,
            content: t`Do you really want to delete bundle ${record.name}?`,
            onOk() {
                deleteBundle(record.id);
            },
            onCancel() {},
            okText: t`Delete`,
            cancelText: t`Cancel`,
        });
    };

    getItems = () => {
        const { record } = this.props;

        const items = [];
        items.push({
            key: 'view',
            label: t`View`,
            url: `/products/bundles/${record.id}`,
            subscription: SubscriptionScopeKey['PRODUCT.BUNDLE'],
        });

        if (record.is_archived) {
            items.push({
                key: 'activate',
                label: t`Activate`,
                action: () => this.toggleActivation(record),
                isUpdate: true,
                subscription: SubscriptionScopeKey['PRODUCT.BUNDLE'],
            });
        }
        else {
            items.push({
                key: 'deactivate',
                label: t`Deactivate`,
                action: () => this.toggleActivation(record),
                isUpdate: true,
                subscription: SubscriptionScopeKey['PRODUCT.BUNDLE'],
            });
        }

        // Delete
        items.push({
            key: 'delete',
            label: t`Delete`,
            disabled: record.is_used,
            action: () => this.deleteBundle(record),
            isDelete: true,
            subscription: SubscriptionScopeKey['PRODUCT.BUNDLE'],
        });

        return items;
    };

    render() {
        return (
            <ListMenu items={this.getItems()} />
        );
    }
}
export default connect(() => ({
}), {
    archiveBundle,
    deleteBundle,
})(ProductBundleListMenu);
